import { BaseClassroom, SimulationRole } from './classroom';
import { ExerciseType } from './scheduled-exercise';

export enum SimulatorType {
  Cloud = 'Cloud',
  Site = 'Site',
}

export enum SimulationState {
  Paused = 'Paused',
  Running = 'Running',
  Unknown = 'Unknown', // It should not be provided by SingleR
}

// TODO: rename to SimulationResult? And make NotStarted/Ongoing part of a separate type?
export enum SimulationStatus {
  Completed = 'Completed',
  Failed = 'Failed',
  NotStarted = 'Not started',
  Ongoing = 'Ongoing',
  Passed = 'Passed',
}

export interface Simulator {
  id: string;
  name: string;
  platform?: number | string;
  thumbnail?: string;
  type: SimulatorType;
}

interface BaseSimulation {
  assessmentVisibility?: boolean;
  endTime?: Date;
  exercise: {
    adHoc: boolean;
    id: string;
    title: string;
    type: ExerciseType;
    name: string;
  };
  id: string;
  name: string;
  simulator: Pick<Simulator, 'name' | 'type' | 'platform'>;
  startTime: Date;
  status: SimulationStatus;
}

export interface Simulation extends BaseSimulation {
  position: string;
}

export type ClassroomSimulation = BaseClassroom & BaseSimulation;

// Simulation detail for a student in Teach
export type StudentSimulation = Simulation & { student: { avatar?: string; name: string } };

// List of cards
export type SimulationSummary = Omit<Simulation, 'exercise' | 'simulator'>;

export type ActiveSimulation = LoadingSimulation | RunningSimulation;

interface SimulationExercise {
  id?: string; // From ScheduledExercise (assignmentGroup)
  name: string; // From sanity
  type: ExerciseType;
}

export interface LoadingSimulation {
  exercise: SimulationExercise;
  id: string;
  url?: string; // Only simulations loading in the cloud have a URL
  message: string;
  name?: string;
  position?: string;
  progress: number; // [0-100]
  role: SimulationRole;
  simulator: {
    name?: string;
    type: SimulatorType;
  };
  state?: SimulationState;
}

export interface RunningSimulation {
  exercise: SimulationExercise;
  id: string;
  message: string;
  name: string;
  position?: string;
  progress: 100;
  role: SimulationRole;
  simulator: {
    id: string;
    name: string;
    type: SimulatorType;
  };
  state: SimulationState;
  url?: string; // Only simulations running in the cloud have a URL
}
